import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../medieval-office-kit';

const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art, f } = ctx;

  // Cool blue-grey vaulted undercroft — hushed, intimate, away from the bustle.
  place(ctx, f.rug(art, 200, 200), 1160, 1000);

  // Casks lining the corners (interior x992..1328, y852..1148; door gap north x1100..1220).
  for (const [rx, ry] of [[1024, 906], [1296, 906], [1024, 1092], [1296, 1092]] as const) {
    place(ctx, kit.wineRack(art, 70, 86), rx, ry);
  }
  place(ctx, kit.barrelStack(art), 1024, 1000);

  // Reserve casks, crest-stamped.
  place(ctx, kit.cask(art), 1060, 1088);
  place(ctx, kit.cask(art), 1280, 912);

  // HERO tasting table — leave its spot clear of obstruction, ring it with high-back chairs.
  place(ctx, kit.smallTable(art, 40), 1160, 1000);
  place(ctx, kit.woodChair(art, 0), 1110, 1000);          // cellar-chair-1
  place(ctx, kit.woodChair(art, Math.PI), 1210, 1000);    // cellar-chair-2
  place(ctx, kit.woodChair(art, Math.PI / 2), 1160, 955); // cellar-chair-3
  place(ctx, kit.woodChair(art, -Math.PI / 2), 1160, 1045); // cellar-chair-4

  // LOW, intimate light — the dimmest room: a single candelabra, NO torches.
  place(ctx, kit.candelabra(art), 1160, 932);

  // Trailing ivy so no corner reads as cold stone.
  place(ctx, f.plant(art, 'fern'), 1300, 1000);
};

export default decorate;
